export function arrayID(arr: {id: string}[]): string {
  return arr.map(x => x.id).join(",")
}
